import PayPal from './PayPalWrapper';

export default PayPal;
